(function () {
  'use strict';

  angular.module('mgpCorregedoriaApp.validacao')
    .controller('ModalInstanceConfirmacaoAgendamento', ModalInstanceConfirmacaoAgendamento);

  function ModalInstanceConfirmacaoAgendamento($uibModalInstance, periodoSelecionado,
    AgendamentoService, toaster, i18n) {

    var vm = this;
    vm.periodoSelecionado = periodoSelecionado;
    vm.cancelar = cancelar;
    vm.realizarAgendamento = realizarAgendamento;

    function cancelar() {
      $uibModalInstance.dismiss('cancel');
    }

    function realizarAgendamento() {
      AgendamentoService.realizarAgendamento(vm.periodoSelecionado.periodo)
      .then(() => {
        $uibModalInstance.close();
        toaster.pop("success",
          i18n.translate("menu.agendamento.relatorio.eleitoral"),
          i18n.translate("relatorio.eleitoral.sucesso"));
      }).catch( () => {
        $uibModalInstance.dismiss();
      });
    }
  }
})();
